<template>
  <div>
    <select class="form-control" @change="onChanged($event)" :style="style">
      <option selected value="0"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.BYTECODE"
        :selected="selectedVal == item.BYTECODE"
      >
        {{ `${item.BYTECODE}: ${item.BYTEDES}` }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();

export default {
  name: "Period",
  props: {
    onChanged: Function,
    selectedVal: Number,
    style: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      this.items = await masterDataProvider.getPeriod({
        token: this.token,
        lang: this.currentLang,
      });
      this.togglePreLoader(false);
    },
  },
  watch: {
    currentLang() {
      this.loadData();
    },
  },
};
</script>
